module.exports = __webpack_public_path__ + "static/media/lunch2.993ffc0b.jpg";